// extracted by mini-css-extract-plugin
module.exports = {"error":"Error_error__39g7A","errorCTA":"Error_errorCTA__3On3l"};